/**
 * Groups items by their line property
 */
export const groupByLine = <T extends {line?: number}>(
  items: T[],
): [number, T[]][] => {
  const grouped: Record<number, T[]> = {}
  items.forEach(item => {
    const line = item.line ?? 1
    if (!grouped[line]) grouped[line] = []
    grouped[line].push(item)
  })
  return Object.entries(grouped)
    .map(([k, v]) => [Number(k), v] as [number, T[]])
    .sort(([a], [b]) => a - b)
}
